import { useEffect, useLayoutEffect } from 'react';

// To avoid the "useLayoutEffect does nothing on the server" warning from React,
// this hook conditionally swaps to useEffect during SSR
const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

export default useIsomorphicLayoutEffect;
